import {Link, useLocation} from "react-router-dom";
import styles from './breadcrumb.module.scss';
import {useSelector} from "react-redux";

const Breadcrumbs = () => {
  const location = useLocation();
  let currentLink = '';
  function convertToWords(inputString) {
    const words = inputString.split(/(?=[A-Z])/);
    return words[0].split("-").map(word => word[0].toUpperCase()+ word.substring(1)+" ");
  }

  const locationsArr =  location.pathname.split('/')
    .filter(location => location !== '');

  const search = location.search;
  const crumbs =
      locationsArr
      .map((location, idx) => {
        currentLink += `/${location}`;
        return (
          <>
            <li>
              <Link
                to={idx === locationsArr.length - 1 ? currentLink + search : currentLink}
              >{convertToWords(location).join('').split('-').join(' ')}</Link>
            </li>
            {
              idx !== locationsArr.length - 1 && (
                <span className={styles.slash}> / </span>
              )
            }
          </>
        )
      })
  return (
    <ul className={styles.breadcrumb}>
      {crumbs}
    </ul>
  )
}

export default Breadcrumbs;
